import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import CompetitionScorers from 'app/components/competitions/CompetitionScorers';
import {useDispatch} from 'react-redux';
import {TITLE_POSTFIX} from 'app/seo/seo.constants';
import {Helmet} from 'react-helmet-async';
import {object} from 'prop-types';
import {fetchCupScorers} from 'app/routes/cup/CupScorersPageActions';
import {CupScorersPageReducer} from 'app/routes/cup/CupScorersPageReducer';
import {useInfiniteScrollComponentState} from 'app/hooks/useInfiniteScroll';
import {useParams} from 'react-router';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';

const CupScorersPage = () => {
  const {restoredData} = useRestoreData('CupScorersPage');
  const {cupSlug, seasonSlug} = useParams();
  const dispatchRedux = useDispatch();

  const initialState = restoredData ?? {
    metaCup: {},
    isFetching: false,
    scorers: [],
    nextUrl: '',
    error: null,
  };
  const [state, dispatch] = useReducer(CupScorersPageReducer, initialState);

  const loadData = reloading => fetchCupScorers(cupSlug, seasonSlug, dispatchRedux, reloading)(dispatch, state);

  const {metaCup, scorers, isFetching, error} = state;
  useInfiniteScrollComponentState(loadData, scorers.length);
  useFetchData(state, loadData, 'CupScorersPage');

  const headerParentName = seasonSlug && metaCup.season ? `${metaCup.name} ${metaCup.season.name}` : metaCup.name;

  const districtName = metaCup?.district?.name ?? '';
  const isActive = metaCup?.active;
  const title = `Torjägerliste - ${headerParentName} - ${districtName}${TITLE_POSTFIX}`;
  const robots = isActive ? 'index, nofollow' : 'noindex, follow';
  const meta = [
    {
      name: 'description',
      content: `Die aktuelle Torschützenliste absteigend nach Toren des Turniers ${headerParentName} - Kreis ${districtName}.`,
    },
    {
      name: 'robots',
      content: robots,
    },
  ];

  return (
    <ContentAdDesktop noTabs top='4.5rem'>
      <Helmet title={title} meta={meta} />
      <CompetitionScorers isFetching={isFetching} scorers={scorers} isCup={true} error={error} />
    </ContentAdDesktop>
  );
};

CupScorersPage.propTypes = {
  match: object.isRequired,
};

export default CupScorersPage;
